module.exports = "/static/assets/7bd7487b704797cb5ab3cb441486ea70.svg";